module.exports = __webpack_public_path__ + "static/mtb-e489eb357440e782ff666e0eb6e77cde.jpg";